import React from "react"
import { InlineContainer } from "components/Form/FormFields/FieldParts/FieldContainer"
import Label from "components/Form/FormFields/FieldParts/Label"
import Input from "components/Form/FormFields/FieldParts/Input"
import InputFeedback from "components/Form/FormFields/FieldParts/InputFeedback"

const InlineInput = props => (
  <InlineContainer inline style={{ marginBottom: "0.5rem" }}>
    <Input {...props} style={{ marginBottom: 0 }} />
    <Label htmlFor={props.id} {...props}>
      {props.label}
    </Label>
    <InputFeedback {...props} />
  </InlineContainer>
)

export default InlineInput



// WEBPACK FOOTER //
// ./src/components/Form/FormFields/InlineInput/index.js